import { useAppSelector } from "@/common/store/redux";

export const useFeatureDisabled = (featureFlag: string) => {
  const disabledFeatureFlags = useAppSelector(
    (state) => state.config.disabledFeatureFlags,
  );

  if (disabledFeatureFlags && typeof disabledFeatureFlags.get === "function") {
    return disabledFeatureFlags.get(featureFlag) ?? false;
  }

  return false;
};
